import * as ReactDOM from 'react-dom';
import { getmessage,displaymaindiv } from './Dynamictable';
import { imgb64,chekf } from './utility';
import axios from 'axios';
import Configdata from './Defaultdata';
import { aroffers,getcolmvalbykypr } from './userdefaultdata';
import {txtnullchk} from './validation';
import Usersession from './Usersession';
export const sendpost=(code: any,ofrid: any)=>{
let strimg = "";
const offrs = aroffers;
const ofrname = getcolmvalbykypr(offrs,'id',ofrid,'oname');



function enabledisplydays(){
const txtdays = document.getElementById('txtdisplaydays') as HTMLInputElement;
const txtdisplayaftr = document.getElementById('txtnoofdays') as HTMLInputElement;
let afterdays = Usersession.getPostexpdays();
txtdisplayaftr.value = afterdays;

txtdays.disabled = false;

if(ofrid == 0){
 getmessage('Please check offers','get points by check your luck');

//getmessage('Each day 5 point chargable','If less than 50 points Please check offers');
//txtdays.disabled = false;
}
else if(ofrid == 1){
//getmessage('Each day 5 point chargable next to 10 days','If less than 50 points Please check offers');
 getmessage('Please check offers','get points by check your luck');

//txtdays.disabled = false;
txtdays.value = "30";
}
else{
 getmessage('Please check offers','get points by check your luck');

//getmessage('Each day 5 point chargable','If less than 50 points Please check offers');
txtdays.value = "30";

} 
}
function uploadimg(){
const pfp = document.getElementById('prophoto') as HTMLInputElement;
pfp.click();
}
function hideshowdiv(sts:any){
const photodiv = document.getElementById('postingphotodiv') as HTMLElement;
const postingdiv = document.getElementById('postingtableinner') as HTMLElement;
if(sts == 1){
photodiv.style.display = 'block';
postingdiv.style.display = 'none';
}
else
{
photodiv.style.display = 'none';
postingdiv.style.display = 'block';

}

}
function uploadproimage(strimg64:any){
hideshowdiv(1);
const pimage = document.getElementById('imgfromstr')  as HTMLElement;


const imgsrc = getimage(strimg64);

ReactDOM.render(imgsrc,pimage);
strimg = strimg64;
}
function uploadingstart(){
if(strimg == "")getmessage('Try again','');
else
uploadtoserver(strimg);
}
function uploadtoserver(strimg64:any){
	 try {
		
		 const response = axios.post(Configdata.srvurl + '/inserprophoto', {
    		
		procode:code,
		photo:strimg64
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const procd = result.data;
               
                //getmessage(procd,'');
	       	completeupload();	
		
	        });		
              }
          
          }
        catch (e) {
        //    debugger;

        }

}
function closeupload(){
hideshowdiv(0);
}
function completeupload(){
const txtupload = document.getElementById('txtprogress')  as HTMLInputElement;
txtupload.value = "Uploading Completed";
txtupload.style.backgroundColor='green';

}
function uploadongoing(){
const txtupload = document.getElementById('txtprogress')  as HTMLInputElement;
txtupload.value = "Uploading on way";
txtupload.style.backgroundColor='red';

}

function pfpupload(e: any){
		uploadongoing();
               const selectedFile = e.target.files[0];
               const ftpe = chekf(selectedFile);
               
               if(ftpe == 'png' || ftpe == 'jpeg'){
	       var base64String ="";
               imgb64(selectedFile).then((result:any) => {
	        base64String = result;
		strimg = base64String;
		uploadproimage(strimg);
    		}).catch(err => {
        	  
    		});
	       }
	       else{
 		getmessage('Please upload png or jpg file','');
	        }
          
	}
function isvalidatedctrls(){
	let isvalidate = true;
	const txtdays = document.getElementById('txtdisplaydays') as HTMLInputElement;
        const txtaftrdays = document.getElementById('txtnoofdays') as HTMLInputElement;
	
        let afterdays = Usersession.getPostexpdays();
        if(parseInt(afterdays) > 0){
	
	 if(txtaftrdays){
          const postafterdays = txtaftrdays.value;
	   if(parseInt(afterdays) > parseInt(postafterdays)){
		getmessage(' please enter more after no of days display  ','');
	  	 return false;
	 }
	}	
	}

	if(txtnullchk(txtdays)){
	  getmessage('Enter Days to display','');
	  return false;
	}
	else if(txtnullchk(txtaftrdays)){
	 getmessage('Atleast 0 enter for days after display','');
	  return false;

	}
	
	
	return isvalidate;	
    }	

function postingnow(){

         
	 try {
		if(isvalidatedctrls()){
		getmessage('On Process Please wait......','')
		let daysvalue = "10";
          	const txtdays = document.getElementById('txtdisplaydays') as HTMLInputElement;

		const txtaftrdays = document.getElementById('txtnoofdays') as HTMLInputElement;
		if(txtdays){
 			if(txtdays.value.length > 0){ 
				daysvalue = txtdays.value;
		        }
		}
		
		let afterday  = "0";
		if(txtaftrdays.value.length >0) afterday = txtaftrdays.value;
		//const usrid = localStorage.getItem("id");
	        const usrid = "30";
                const response = axios.post(Configdata.srvurl + '/insertpostingpro', {
    		displaydays:daysvalue,
		Afterdaysdsply:afterday,
		photo:strimg,
		pcode:code,
		userid:usrid,
		upin:localStorage.getItem("id")
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const procd = result.data;
               const refid = 'Reference  '+ procd;
                getmessage(refid,'');
	       		
		displaymaindiv();
	        });		
              }
	     		
	    }
          }
        catch (e) {
        //    debugger;
	getmessage('Something went Wrong','');

	
        }
}
return(
	<div className="per100">
		<div id= "postingtableinner" className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'auto'}}>
		<div className="postingtablediv">
			 <table className="postingtable">
			<tr>
		      	     <td>
				<div className="postingrowdiv" style={{height:'35px',color:'#ffffff'}}>
				 {code}
			        </div>
			
			     </td>
			   </tr>
		     	   <tr>
		      	     <td>
				<div className="postingrowdiv" style={{width:'50%',float:'left'}}>
		<input type="text" placeholder="Enter dispaydays"
			onKeyPress={(event)=>{
			 if(!/[0-9]/.test(event.key)){
			    event.preventDefault();
			   }
			 }
			}	
			 id="txtdisplaydays" className="postingtxtbox" disabled/>
			</div>
			<div className="postingrowdiv" style={{width:'50%',float:'left'}}>
			 <input type="button" onClick={enabledisplydays} value="Enable days" id="btndisplaydays" style={{height:'35px'}} className="postingtxtbox"/>
			</div>
			     </td>
			   </tr>
			   <tr>
		      	     <td>
				<div className="postingrowdiv" style={{height:'35px',color:'#ffffff'}}>
		Display from today enter 0  
			</div>
			
			     </td>
			   </tr>
			 <tr>
		      	     <td>
				<div className="postingrowdiv" >
			<input type="text"  placeholder="After No of days Display" 
			onKeyPress={(event)=>{
			 if(!/[0-9]/.test(event.key)){
			    event.preventDefault();
			   }
			 }
			}	
			id="txtnoofdays" className="postingtxtbox"/>
			</div>
			
			     </td>
			   </tr>
			 <tr>
		      	     <td>
				<a onClick={uploadimg} href="#">
				<div className="postingrowdiv" style={{height:'35px',color:'#ffffff',textAlign:'center'}}>
				   Select Photo 
			         </div>
			      </a>
			
			     </td>
			   </tr>
			 <tr>
		      	     <td>
				<div className="postingrowdiv" style={{height:'35px',color:'#ffffff'}}>
			<a href="#" onClick={postingnow} className="profile-items" style={{float:'right',paddingBottom:'4px',width:'auto'}}>Post Now</a>
			         </div>
			
			     </td>
			   </tr>
	
			</table> 
		</div>
		
		</div>	
		<div style={{display:'none'}}>
		<input type="file" onChange={e =>pfpupload(e)} id="prophoto" />
		</div>
		<div id= "postingphotodiv" className="postingouterdiv" style={{overflow:'hidden',height:'auto',display:'none',position:'fixed',top:'35px',left:'15px',width:'95vw',backgroundColor:'gray'}}>
		<div id = "imgfromstr" className="per100">
			<img src={strimg} id="propertimage" style={{width:'100%',height:'70vh'}} />
		</div>	
		<div style={{width:'100%',height:'30px'}}>
			
	<input type="text" value=""  style={{width:'80%',textAlign:'center',backgroundColor:'red',color:'#ffffff'}}  id="txtprogress" />
	<input type="button" value="Upload"  onClick={uploadingstart} style={{width:'9%',textAlign:'center',backgroundColor:'gray',color:'#ffffff'}} />
			
	<input type="button" value="close"  onClick={closeupload} style={{width:'9%',textAlign:'center',backgroundColor:'gray',color:'#ffffff'}} />
			
		</div>	
	    </div>
    
	</div>
);
}

export const enableelementbyid = ()=>{
const Pdiv = document.getElementById('txtdisplaydays') as HTMLInputElement;
Pdiv.disabled = false;
Pdiv.value ="10";
	
}
export const getimage = (str64: any)=>{
return(

<img src={str64} style={{width:'100%',height:'70vh'}} />

);
	
}
